import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionTitle, ScoreBadge, RatingCell } from "@/components/AppTable";
import { formatNumber } from "@/lib/format";
import { Sparkle, Plus, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function Opportunities() {
  const [items, setItems] = useState([]);
  const [leadPkgs, setLeadPkgs] = useState(new Set());

  const load = async () => {
    const [r, l] = await Promise.all([api.get("/publisher-opportunities?limit=50"), api.get("/leads")]);
    setItems(r.data);
    setLeadPkgs(new Set(l.data.map(x => x.package_name)));
  };
  useEffect(() => { load(); }, []);

  const addLead = async (pkg) => {
    try {
      await api.post("/leads", { package_name: pkg });
      toast.success("Lead added");
      setLeadPkgs(new Set([...leadPkgs, pkg]));
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-8 space-y-6">
      <SectionTitle eyebrow="High potential" title="Publisher Opportunities" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((a) => (
          <div key={a.package_name} className="border border-border p-5 bg-card hover:border-primary/50 transition-colors">
            <div className="flex items-start gap-3">
              {a.icon && <img src={a.icon} alt="" className="w-12 h-12 rounded-sm border border-border" />}
              <div className="flex-1 min-w-0">
                <Link to={`/apps/${a.package_name}`} className="font-heading font-bold text-base hover:underline block truncate">
                  {a.name}
                </Link>
                <div className="text-xs text-muted-foreground">{a.developer} · {a.category}</div>
              </div>
              <ScoreBadge score={a.lead_score} />
            </div>
            <div className="flex items-center gap-4 mt-3 text-xs">
              <RatingCell rating={a.rating} />
              <span className="font-mono text-muted-foreground">{formatNumber(a.review_count)} reviews</span>
              <span className="font-mono text-muted-foreground">{a.install_range}</span>
            </div>
            <div className="mt-3 border-t border-border pt-3">
              <div className="overline-label text-muted-foreground mb-1.5 flex items-center gap-1">
                <Sparkle size={11} /> Why this opportunity
              </div>
              <ul className="text-xs space-y-0.5 list-disc pl-4">
                {a.lead_reasons?.map((r, i) => <li key={i}>{r}</li>)}
                {!a.lead_reasons?.length && <li>Baseline traction</li>}
              </ul>
            </div>
            <div className="mt-3 flex justify-end">
              {leadPkgs.has(a.package_name) ? (
                <span className="text-xs text-emerald-600 flex items-center gap-1"><Check size={12} /> In pipeline</span>
              ) : (
                <button data-testid={`btn-lead-${a.package_name}`} onClick={() => addLead(a.package_name)}
                        className="text-xs bg-primary text-primary-foreground px-3 py-1.5 rounded-sm flex items-center gap-1 hover:opacity-90">
                  <Plus size={12} /> Add lead
                </button>
              )}
            </div>
          </div>
        ))}
        {!items.length && <div className="col-span-full text-sm text-muted-foreground text-center py-16 border border-border">
          No opportunities yet. Run a discovery from Admin to populate data.
        </div>}
      </div>
    </div>
  );
}
